import swal from 'sweetalert';
var config = require('../config');

export const fetchRequest = ({
    url,
    method = 'GET',
    obj = null,
    modal = null,
    message_modal = "",
    requireToken = true,
    is_file = false
})=>{
    let apiUrl = config.default.apiGateway.URL+url;
    let token = sessionStorage.getItem('token');

    if(modal !== null){
        modal.handleShow(message_modal);
    }

    return fetch(apiUrl,{
        method: method,
        body: obj !== null ? JSON.stringify(obj) : null,
        responseType: is_file ? 'blob' : null,
        headers: new Headers(
            requireToken ?
                {
                    'Authorization' : 'Bearer '+token,
                    'Content-Type'  : 'application/json',
                    'Accept'        : is_file ? 'application/pdf' : 'application/json'
                }
            : 
                {
                    'Content-Type'  : 'application/json',
                    'Accept'        : 'application/json'
                }
        )
    }).then(res => {
        if(modal !== null){
            modal.handleClose();
        }

        if(res.ok){
            return is_file ? res.blob() : res.json();
        }else{
            res.text().then(msg => {
                
                if(typeof msg === 'string' && msg.indexOf('{') === -1){
                    swal('Error', msg, 'error');
                }else{
                    let auxmsg = JSON.parse(msg);

                    if(auxmsg.Message){
                        swal('Error', auxmsg.Message, 'error');
                    }else{
                        swal('Error', msg, 'error');
                    }
                }
                
            })
        }
    }).then(response => {
        if(response !== undefined){
            return response;
        }
    }).catch(error => {
        if(modal !== null){
            modal.handleClose();
        }
    })
}